import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import coordtransform from 'coordtransform';
import { isPromise } from './tools';

dayjs.extend(duration);

let UploadOwnLocation_TIMER = null;

// 计算2点间距离
export function getDistance(lat1, lng1, lat2, lng2) {
  if (!lat1 || !lng1) return null;
  const rad = (d) => {
    return (d * Math.PI) / 180.0;
  };
  let radLat1 = rad(lat1);
  let radLat2 = rad(lat2);
  let a = radLat1 - radLat2;
  let b = rad(lng1) - rad(lng2);
  let s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = Math.round(s * 6378.137 * 1000);
  return fixedDistance(s);
}

export function fixedDistance(s) {
  let distance = 0;
  if (s > 1000) {
    distance = (s / 1000).toFixed(1) + 'km';
  } else {
    distance = s + 'm';
  }
  return distance;
}

// 如果是高德地图坐标， 转换为wgs84
export function gcj02towgs84(data) {
  const wgsPoint = coordtransform.gcj02towgs84(data.lng, data.lat);
  return {
    lng: wgsPoint[0],
    lat: wgsPoint[1]
  };
}
// 如果是百度地图坐标， 转换为wgs84
export function bd09towgs84(data) {
  const amapPoint = coordtransform.bd09togcj02(data.lng, data.lat);
  const wgsPoint = coordtransform.gcj02towgs84(amapPoint[0], amapPoint[1]);
  return {
    lng: wgsPoint[0],
    lat: wgsPoint[1]
  };
}

// wgs84togcjo2
export function wgs84togcj02(lng, lat) {
  const amapPoint = coordtransform.wgs84togcj02(lng, lat);
  return amapPoint;
}

export function getLocation(type = 'gcj02') {
  if (typeof type !== 'string') {
    throw new Error('Location.getLocation:: params.type !== string');
  }
  return new Promise((resolve, reject) => {
    // #ifdef MP-WEIXIN
    uni.getSetting({
      success(res) {
        console.log(res);
        if (res.authSetting['scope.userLocation'] === false) {
          // 用户拒绝过权限，引导用户手动开启
          uni.showModal({
            title: '位置权限申请',
            content:
              '需要获取您的地理位置信息来计算距离，请在设置中开启位置权限',
            confirmText: '去设置',
            success(modalRes) {
              if (modalRes.confirm) {
                uni.openSetting({
                  success(settingRes) {
                    if (settingRes.authSetting['scope.userLocation']) {
                      // 用户开启了权限，重新获取位置
                      getLocationCore();
                    } else {
                      reject(new Error('用户拒绝位置权限'));
                    }
                  }
                });
              } else {
                reject(new Error('用户取消权限设置'));
              }
            }
          });
        } else {
          // 权限正常或未询问过，直接获取位置
          getLocationCore();
        }
      },
      fail(er) {
        console.log(er);
        // getSetting失败，直接尝试获取位置
        getLocationCore();
      }
    });
    // #endif

    // #ifndef MP-WEIXIN
    getLocationCore();
    // #endif

    function getLocationCore() {
      uni.getLocation({
        type,
        success(res) {
          resolve(res);
        },
        fail(err) {
          console.error('getLocation fail:', err);
          reject(err);
        }
      });
    }
  });
}

/**
 * @param {Object} params.type - 3：patrol；2：maintain
 * @param {String} params.morph_id - 计划ID
 * @param {String} params.lnglat - 当前所在位置 lng,lat
 * @param {String} params.project_id - 项目ID
 *
 * @returns Promise 当且仅当成功获取完定位、api提交成功才触发 resolve
 */
export function _uploadOwnLocation(params) {
  return new Promise(() => {
    Location.getLocation().then((res) => {
      params.lnglat = `${res.longitude},${res.latitude}`;
    });
  });
}

// 持续获取定位
export function continueUploadOwnLocation(params) {
  _uploadOwnLocation(params)
    .catch((err) => {
      console.error('持续上报定位错误', err);
    })
    .finally(() => {
      UploadOwnLocation_TIMER = setTimeout(
        () => continueUploadOwnLocation(params),
        8000
      );
    });
}

export function breakUploadOwnLocation() {
  if (UploadOwnLocation_TIMER) {
    clearTimeout(UploadOwnLocation_TIMER);
  }
}

// 订阅消息
export function subscribeMessage(tmplIds) {
  // #ifdef MP-WEIXIN
  if ((tmplIds ?? '') !== '') {
    tmplIds = Array.isArray(tmplIds) ? tmplIds : [tmplIds];
    return new Promise((resolve) => {
      wx.requestSubscribeMessage({
        tmplIds: tmplIds,
        complete(res) {
          resolve(res);
        }
      });
    });
  }
  // #endif
}

export function navTo(url, item = {}) {
  let params = '';
  if (Object.keys(item).length > 0) {
    params = Object.entries(item).reduce((p, [key, value]) => {
      return value ? p + `&${key}=${value}` : p;
    }, '');
    params = (params ?? '') !== '' ? `?${params}` : '';
  }
  uni.navigateTo({
    url: url + params
  });
}

export function toast({ title, ...params }) {
  uni.showToast({
    title,
    icon: 'none',
    duration: 2500,
    ...params
  });
}

export function showModal({ title = '提示', message }) {
  return new Promise((resolve, reject) => {
    uni.showModal({
      title,
      content: message,
      confirmColor: '#1988F3',
      success(res) {
        if (res.confirm) {
          resolve();
        } else if (res.cancel) {
          reject(res.cancel);
        }
      }
    });
  });
}

/**
 * 调用拦截器函数
 * 这个函数用于调用一个拦截器函数，并处理它的返回值
 * 如果拦截器函数返回一个 Promise，则处理 Promise 的完成和取消情况
 * 如果拦截器函数返回一个布尔值，则根据布尔值调用 done 或 canceled 回调
 *
 * @param {Function} interceptor - 要调用的拦截器函数
 * @param {Object} options - 包含调用参数和回调函数的对象
 * @param {Array} options.args - 传递给拦截器函数的参数数组，默认为空数组
 * @param {Function} options.done - 拦截器成功完成时调用的回调函数
 * @param {Function} options.canceled - 拦截器被取消时调用的回调函数
 * @param {Function} options.error - 拦截器出错时调用的回调函数，默认为空函数（noop）
 */
export function callInterceptor(
  interceptor,
  { args = [], done = () => {}, canceled = () => {}, error = () => {} }
) {
  if (interceptor) {
    const returnVal = interceptor.apply(null, args);
    if (isPromise(returnVal)) {
      returnVal
        .then((value) => {
          if (value) {
            done(value);
          } else if (canceled) {
            canceled(value);
          }
        })
        .catch(error);
    } else if (returnVal) {
      done(returnVal);
    } else if (canceled) {
      canceled();
    }
  } else {
    done();
  }
}

export function getPayWaitTime(timestamp, createTime) {
  let systemConfig = uni.getStorageSync('systemConfig');
  let waitTime = systemConfig.goods_order_wait_pay_time * 60;
  let diffTime = dayjs(timestamp * 1000).diff(dayjs(createTime), 'second');
  return {
    waitTime,
    diffTime,
    needPayTime: (waitTime - diffTime) * 1000
  };
}

export function compose(...func) {
  return func.reduce(
    (pre, cur) =>
      (...args) =>
        pre(cur(...args))
  );
}

// 复制终端编号
export function copy(no) {
  uni.setClipboardData({
    data: no,
    success: () => {
      toast({ title: '复制成功', duration: 1500 });
    },
    fail: (err) => {
      console.log(err);
      toast({ title: '复制失败', icon: 'none', duration: 1500 });
    }
  });
}

export function dealUrl(url) {
  let params = {};
  if (!url) return params;

  // 增强：优先尝试解析为完整URL
  let queryString = '';
  try {
    const urlObj = new URL(url);
    queryString = urlObj.search.substring(1); // 正确提取查询参数
  } catch {
    queryString = url.split('?').slice(1).join('?'); // 处理含多个?的情况
  }

  // 处理参数编码
  queryString.split('&').forEach((pair) => {
    const [key, value = ''] = pair.split(/=(.*)/); // 使用正则分割防止值中含=
    if (key) {
      try {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      } catch (e) {
        params[key] = value; // 保持原始值
      }
    }
  });
  return params;
}

export function makePhoneCall(phone) {
  uni.makePhoneCall({
    phoneNumber: phone
  });
}

export const withInstall = (comp) => {
  comp.install = (app) => {
    app.component(comp.name, comp);
  };
  return comp;
};
